export default __webpack_public_path__ + "static/media/blog-img-3.6d7d0b89.webp";